<template>
    <div>
        <v-navigation-drawer
                v-model="drawer"
                app
                temporary
                absolute
                right
        >
            <v-toolbar
                    color="#002EA7"
                    style="vertical-align: center;padding: 1em !important;"
                    class=""
                    dark
                    right
                    :prominent = true
            >
                <v-toolbar-title>Menü</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click.stop="drawer = !drawer">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-list >

                <template v-for="(item, index) in items">
                    <v-list-tile v-show="item.active" :key="index">
                        <v-list-tile-content>
                            <router-link :to=item.to>
                                <v-btn flat color="primary" dark>
                                    <v-icon left>{{item.icon}}</v-icon>
                                    {{item.title}}
                                </v-btn>
                            </router-link>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider :key="`divider-${index}`"></v-divider>
                    <v-divider></v-divider>
                </template>
            </v-list>
        </v-navigation-drawer>
        <v-toolbar
                color="#002EA7"
                style="vertical-align: center;padding: 16px 8px !important;line-height:1.5em;"
                class=""
                dark
                right
                :prominent = true
        >
            <v-avatar
                    size="70px"
                    color="transparent"
                    class="ma-0"
                    style="max-width:70px"
            >
                <v-img class="ma-0" src="images/signet/test.svg" alt=""></v-img>
            </v-avatar>
            <v-toolbar-title>4gewinnt</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-side-icon  @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        </v-toolbar>
    </div>
</template>

<script>
    export default {
        name: "VierGewinntNavigation",
        data() {
            return {
                drawer: false,
                items: [
                    { title: 'Startseite', active: true, to: 'start', icon: 'home' },
                    { title: 'Versichern', active: true, to: 'home', icon: 'portrait' },
                    { title: 'Kontakt', active: true, to: 'contact', icon: 'contact_support' }
                ]
            }
        }
    }
</script>

<style scoped>

</style>
